import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';

import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { Router } from '@angular/router';
import { inject } from '@angular/core';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> =>
    {
        const _authService = inject(AuthService);
        const _router = inject(Router);
    
        // Si la URL que queremos excluir está en la petición, no le agregamos el header
        const excludedUrl = 'https://apis.gometa.org/cedulas/';
        if (req.url.indexOf(excludedUrl) > -1) {
            return next(req);
        }
    
        // Clonar la solicitud
        let newReq = req.clone();
    
        // Agregar el header Authorization sólo si existe el token y no está expirado
        if (_authService.accessToken && !AuthUtils.isTokenExpired(_authService.accessToken)) {
            newReq = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + _authService.accessToken),
            });
        }
    
        // Respuesta
        return next(newReq).pipe(
            catchError((error) =>
            {
                // Solo el 401 expulsa: es la sesion caida. El 403 y el 404 de una
                // peticion se propagan al llamante, que los muestra con manageErrors
                // sin sacar al usuario de donde estaba (D20).
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    _router.navigateByUrl('/sign-out');
                }
                return throwError(error);
            }),
        );
    };
